/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { LaunchDarklyError } from "./launchdarklyerror.js";

export type UnauthorizedErrorRepData = {
  /**
   * Specific error code encountered
   */
  code: string;
  /**
   * Description of the error
   */
  message: string;
};

export class UnauthorizedErrorRep extends LaunchDarklyError {
  /**
   * Specific error code encountered
   */
  code: string;

  /** The original data that was passed to this error instance. */
  data$: UnauthorizedErrorRepData;

  constructor(
    err: UnauthorizedErrorRepData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;
    this.code = err.code;

    this.name = "UnauthorizedErrorRep";
  }
}

/** @internal */
export const UnauthorizedErrorRep$inboundSchema: z.ZodType<
  UnauthorizedErrorRep,
  z.ZodTypeDef,
  unknown
> = z.object({
  code: z.string(),
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new UnauthorizedErrorRep(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type UnauthorizedErrorRep$Outbound = {
  code: string;
  message: string;
};

/** @internal */
export const UnauthorizedErrorRep$outboundSchema: z.ZodType<
  UnauthorizedErrorRep$Outbound,
  z.ZodTypeDef,
  UnauthorizedErrorRep
> = z.instanceof(UnauthorizedErrorRep)
  .transform(v => v.data$)
  .pipe(z.object({
    code: z.string(),
    message: z.string(),
  }));
